import React from 'react';

export interface SunnyIconProps {
  pixelSize: number;
  style?: React.CSSProperties;
  className?: string;
  'aria-hidden'?: React.AriaAttributes['aria-hidden'];
}

export const SunnyIcon: React.FC<SunnyIconProps> = ({ pixelSize, style, className, ...rest }) => (
  <svg
    width={pixelSize}
    height={pixelSize}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    {...rest}
  >
    <path
      d="M1.01765 19.25H26.9823C27.2114 18.6841 27.4046 18.0998 27.5589 17.5H0.441061C0.595447 18.0998 0.788588 18.6841 1.01765 19.25Z"
      fill="currentColor"
    />
    <path
      d="M27.9206 15.5C27.9731 15.0072 28 14.5067 28 14C28 13.9165 27.9993 13.8332 27.9978 13.75H0.00218729C0.000731113 13.8332 0 13.9165 0 14C0 14.5067 0.0269225 15.0072 0.0794152 15.5H27.9206ZM27.5589 10.5C27.7057 11.0701 27.8174 11.6542 27.8917 12.25H0.108314C0.182605 11.6542 0.29433 11.0701 0.441061 10.5H27.5589ZM0.738906 9.5H27.2611C25.387 3.97555 20.1578 0 14 0C7.84221 0 2.61296 3.97555 0.738906 9.5ZM3.71643 23.5C3.21272 22.955 2.75179 22.3699 2.33897 21.75H25.661C25.2482 22.3699 24.7873 22.955 24.2836 23.5H3.71643ZM7.68854 26.5C9.58499 27.4594 11.7294 28 14 28C16.2706 28 18.415 27.4594 20.3115 26.5H7.68854Z"
      fill="currentColor"
    />
  </svg>
);
